import { motion } from "framer-motion";
import { Lock, Activity, Globe } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const pillars = [
  {
    n: "01",
    icon: Lock,
    title: "Private by default",
    body: "Bank-grade infrastructure with privacy engineered into every layer. Discretion isn't a setting — it's the architecture.",
  },
  {
    n: "02",
    icon: Activity,
    title: "Institutional ledger",
    body: "Event-sourced and reconciled the moment a transfer clears. Every position, exposure and movement, observable in real time.",
  },
  {
    n: "03",
    icon: Globe,
    title: "Global access",
    body: "Audited custody partners and seamless access from anywhere — one calm dashboard, twenty-plus jurisdictions, zero friction.",
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      className="relative bg-[#0A0B0D] py-32 sm:py-40 lg:py-48 border-t border-[#1F2126]"
      data-testid="pillars-section"
    >
      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-20 sm:mb-28">
          <div className="col-span-12 md:col-span-3 t-mono text-[#7A7A78]">
            — § 04 / Pillars
          </div>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1.2, ease }}
            className="col-span-12 md:col-span-9 t-display text-[#F4F2EC] text-3xl sm:text-4xl lg:text-5xl leading-[1] tracking-[-0.035em] max-w-3xl"
          >
            Three primitives. <span className="text-[#7A7A78]">One operating layer for private wealth.</span>
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#1F2126] border-y border-[#1F2126]">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.article
                key={p.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 1, ease, delay: i * 0.1 }}
                className="p-8 sm:p-10 lg:p-12 flex flex-col gap-12 group min-h-[340px]"
                data-testid={`pillar-card-${p.n}`}
              >
                <div className="flex items-start justify-between">
                  <span className="t-mono text-[#7A7A78]">{p.n} / 03</span>
                  <Icon className="w-4 h-4 text-[#7A7A78] group-hover:text-[#F4F2EC] transition-colors" strokeWidth={1.4} />
                </div>
                <div className="mt-auto">
                  <h4 className="t-body text-[#F4F2EC] text-xl sm:text-2xl tracking-[-0.02em] font-light">
                    {p.title}
                  </h4>
                  <p className="mt-4 t-body text-sm text-[#BFBDB6] leading-relaxed max-w-sm">
                    {p.body}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
